export type OrderDetailsList = {
  pagingMetadata: {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
  orderList: OrderDetails[];
};

export type OrderDetails = {
  orderId: number;
  orderNo: string;
  accountNo: string;
  orderByEmail: string;
  ro: string;
  po: string;
  requestedDate: string;
  statusId: number;
  status: string;
  orderImages: OrderImageDetails[];
};

export type OrderImageDetails = {
  attachmentID: number;
  fileUrl: string;
};

export type DraftOrderState = {
  data: OrderDetailsList;
  loading: boolean;
  error: string | null;
  success: boolean;
};

export const initialState: DraftOrderState = {
  data: {
    pagingMetadata: {
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false,
    },
    orderList: [],
  },
  loading: false,
  error: null,
  success: false,
};

export type DraftOrderServiceOperators = {
  draftOrderList: OrderDetailsList;
  fetchAllDraftOrderInfo: (data: DraftOrderPayload) => void;
  deleteDraftOrder: (orderId: number) => void;
};

export type DraftOrderPayload = {
  FromDate: string;
  ToDate: string;
  AccountNo: string;
  Status: number;
  OrderByColumn: string;
  OrderBy: string;
  CountOnly: boolean;
  CompanyCode: string;
};
